import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetResultsSection } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { Chart } from '../../../Shared/Chart';
import { LayerBoundariesOptions } from './LayerBoundariesOptions';

let ResultsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const resultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('Measurements.ResultNotObtainable'), valueOrDefault(false))
  );

  return (
    <WorksheetResultsSection heading="Results">
      {!resultNotObtainable && (
        <NamePrefixModifier appendNamePrefix="Results">
          <Chart />
          <LayerBoundariesOptions />
        </NamePrefixModifier>
      )}
      <ListFieldSection
        visible={resultNotObtainable}
        messages={[{ message: 'Result marked as not obtainable.', severity: 'info' }]}
      />
    </WorksheetResultsSection>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export { ResultsSection };
export default ResultsSection;
